import React from "react";
import { LiaTagSolid } from "react-icons/lia";
import { IoIosRefresh } from "react-icons/io";
import { IoLogoWhatsapp } from "react-icons/io5";
import { RiBuilding2Fill } from "react-icons/ri";
import { MdApartment } from "react-icons/md";
import NewTaskV2 from "components/dialogCommon/templates/NewTaskV2";
import { TagEditor } from "components/dialogCommon/templates/tagEditor";
import { EtapasModal } from "components/dialogCommon/templates/etapasModal";
import { ProdutosModal } from "components/dialogCommon/templates/produtosModal";
import * as IconsSVG from "../../../../../assets/iconsSVG";
import DialogCommon from "../../../../../components/dialogCommon";
import ConcludeTaskForm from "../../../../../components/dialogCommon/templates/concludeTaskForm";
import DesqualifyForm from "../../../../../components/dialogCommon/templates/desqualifyForm";
import HistoricForm from "../../../../../components/dialogCommon/templates/historicForm";
import MultipleShareForm from "../../../../../components/dialogCommon/templates/multipleShareForm";
import MultipleTransferForm from "../../../../../components/dialogCommon/templates/multipleTransferForm";
import MultipleTransferByEquipe from "../../../../../components/dialogCommon/templates/multipleTransferByEquipe";
import ShareForm from "../../../../../components/dialogCommon/templates/shareForm";
import TransferForm from "../../../../../components/dialogCommon/templates/TransferForm";
import AtualizarLeadModal from "../../../../../components/AtualizarLeadModal";
import EnvioMassaPanel from "../../../../whatsapp/components/EnvioMassaPanel";
import { ContatoWA } from "../../../../../services/api/AppWeb_WhatsApp/types";

const TagIcon = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#819DFF",
      border: "8px solid #D5DEFF",
      padding: 2,
      borderRadius: "50%",
      height: 52,
      width: 52,
      marginRight: 12,
    }}
  >
    <LiaTagSolid color="white" size={24} style={{ margin: 0 }} />
  </div>
);

const EtapaIcon = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#D1FADF",
      border: "8px solid #ECFDF3",
      padding: 2,
      borderRadius: "50%",
      height: 52,
      width: 52,
      marginRight: 12,
    }}
  >
    <IoIosRefresh color="black" size={24} style={{ margin: 0 }} />
  </div>
);

const ProdutoIcon = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#D1FADF",
      border: "8px solid #ECFDF3",
      padding: 2,
      borderRadius: "50%",
      height: 52,
      width: 52,
      marginRight: 12,
    }}
  >
    <RiBuilding2Fill color="black" size={24} style={{ margin: 0 }} />
  </div>
);

const ProdutoMultipleIcon = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#2D5BFF",
      border: "8px solid #DBEAFE",
      padding: 2,
      borderRadius: "50%",
      height: 52,
      width: 52,
      marginRight: 12,
    }}
  >
    <MdApartment color="white" size={24} style={{ margin: 0 }} />
  </div>
);

const WhatsAppMassIcon = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#16A34A",
      border: "8px solid #DCFCE7",
      padding: 2,
      borderRadius: "50%",
      height: 52,
      width: 52,
      marginRight: 12,
    }}
  >
    <IoLogoWhatsapp color="white" size={24} style={{ margin: 0 }} />
  </div>
);

interface DialogsProps {
  // Lead context
  anchorLead: string;
  anchorLeadCorretor: string;
  anchorNomeLead: string;
  anchorEtapa: { label: string; value: string };
  anchorSubEtapa: { label: string; value: string };
  anchorProdutos: Array<{ id: string; nome: string }>;
  checked: any[];
  allPagesSelected?: boolean;
  idCorretorOrigem?: string;
  requestLeads: Function;

  // Dialog states
  newTask: boolean;
  setNewTask: (v: boolean) => void;
  concludeTask: boolean;
  setConcludeTask: (v: boolean) => void;
  itemConclude: any;
  disqualify: boolean;
  setDisqualify: (v: boolean) => void;
  shared: boolean;
  setShared: (v: boolean) => void;
  transfer: boolean;
  setTransfer: (v: boolean) => void;
  sharedMultiple: boolean;
  setSharedMultiple: (v: boolean) => void;
  transferMultiple: boolean;
  setTransferMultiple: (v: boolean) => void;
  transferMultipleAdmin: boolean;
  setTransferMultipleAdmin: (v: boolean) => void;
  compartilharMultipleAdmin: boolean;
  setCompartilharMultipleAdmin: (v: boolean) => void;
  historic: boolean;
  setHistoric: (v: boolean) => void;
  openAtualizarModal: boolean;
  setOpenAtualizarModal: (v: boolean) => void;
  selectedLeadId: string;
  tagsOpen: boolean;
  setTagsOpen: (v: boolean) => void;
  etapasOpen: boolean;
  setEtapasOpen: (v: boolean) => void;
  produtosOpen: boolean;
  setProdutosOpen: (v: boolean) => void;

  // Data
  tags: any;
  refetchEtiquetas: () => void;

  // Multiple tags/produtos
  tagsMultipleOpen: boolean;
  setTagsMultipleOpen: (v: boolean) => void;
  tagsMultipleContent: JSX.Element;
  produtosMultipleOpen: boolean;
  setProdutosMultipleOpen: (v: boolean) => void;
  produtosMultipleContent: JSX.Element;
  onSaveProdutosMultiple: () => void;
  onCloseProdutosMultiple: () => void;
  whatsAppMassOpen: boolean;
  setWhatsAppMassOpen: (v: boolean) => void;
  whatsAppMassContacts: ContatoWA[];
}

export const Dialogs: React.FC<DialogsProps> = (props) => (
  <>
    {/* Agendar tarefa (Carteira) */}
    <DialogCommon
      closeText="Fechar"
      saveText="Salvar"
      onClose={() => props.setNewTask}
      onSave={() => {}}
      isRight={false}
      onClean={() => {}}
      title="Agendar tarefa"
      isFilter={false}
      isClose
      width={500}
      maxHeight="680px"
      component={
        <NewTaskV2
          idLead={props.anchorLead}
          idLeadCorretor={props.anchorLeadCorretor}
          dataLead={null}
          lead={{
            idLeadCorretor: props.anchorLeadCorretor,
            nomeLead: props.anchorNomeLead,
          }}
          closeModal={() => props.setNewTask(false)}
          refetch={() => console.log("")}
          fromCarteira
        />
      }
      setOpenModal={props.setNewTask}
      open={props.newTask}
      icon={<IconsSVG.NewTaskDialog />}
    />

    {/* Conclusão da tarefa */}
    <DialogCommon
      closeText="Fechar"
      saveText="Salvar"
      onClose={() => props.setConcludeTask}
      onSave={() => {}}
      isRight={false}
      onClean={() => {}}
      title="Conclusão da tarefa"
      isFilter={false}
      isClose
      width={500}
      component={
        <ConcludeTaskForm
          idLead={props.anchorLead}
          idLeadCorretor={props.anchorLeadCorretor}
          itemConclude={props.itemConclude}
          nomeLead={props.anchorNomeLead}
          onClose={props.setConcludeTask}
          open={props.concludeTask}
          produto={props.itemConclude?.empreendimento}
          hotRefreshFunc={() => console.log("Atualizar")}
        />
      }
      setOpenModal={props.setConcludeTask}
      open={props.concludeTask}
      icon={<IconsSVG.NewTaskDialog />}
    />

    {/* Desqualificar */}
    <DialogCommon
      closeText="Fechar"
      saveText="Salvar"
      onClose={() => props.setDisqualify}
      onSave={() => {}}
      isRight={false}
      onClean={() => {}}
      title="Desqualificar"
      isFilter={false}
      isClose
      width={500}
      component={
        <DesqualifyForm
          isLeadScreen={false}
          idLead={props.anchorLead}
          idLeadCorretor={props.anchorLeadCorretor}
          onClose={props.setDisqualify}
          open={props.disqualify}
          hotRefreshFunc={() => props.requestLeads()}
        />
      }
      setOpenModal={props.setDisqualify}
      open={props.disqualify}
      icon={<IconsSVG.DesqualifyLeadIcon />}
    />

    {/* Compartilhar leads (múltiplos) */}
    <DialogCommon
      closeText="Fechar"
      saveText="Salvar"
      onClose={() => props.setSharedMultiple}
      onSave={() => {}}
      isRight={false}
      onClean={() => {}}
      title="Compartilhar leads"
      isFilter={false}
      isClose
      width={500}
      component={
        <MultipleShareForm
          leads={props.checked as any}
          onClose={props.setSharedMultiple}
          open={props.sharedMultiple}
        />
      }
      setOpenModal={props.setSharedMultiple}
      open={props.sharedMultiple}
      icon={<IconsSVG.ShareLeadIcon />}
    />

    {/* Transferir leads (múltiplos) */}
    <DialogCommon
      closeText="Fechar"
      saveText="Salvar"
      onClose={() => props.setTransferMultiple}
      onSave={() => {}}
      isRight={false}
      onClean={() => {}}
      title="Transferir leads"
      isFilter={false}
      isClose
      width={500}
      height={550}
      component={
        <MultipleTransferForm
          leads={props.checked as any}
          onClose={props.setTransferMultiple}
          open={props.transferMultiple}
          hotRefreshFunc={() => props.requestLeads()}
          transferirTodasPaginas={props.allPagesSelected}
          idCorretorOrigem={props.idCorretorOrigem}
        />
      }
      setOpenModal={props.setTransferMultiple}
      open={props.transferMultiple}
      icon={<IconsSVG.TransferLeadIcon />}
    />

    {/* Compartilhar leads admin (múltiplos) */}
    <DialogCommon
      closeText="Fechar"
      saveText="Salvar"
      onClose={() => props.setCompartilharMultipleAdmin}
      onSave={() => {}}
      isRight={false}
      onClean={() => {}}
      title="Compartilhar leads"
      isFilter={false}
      isClose
      width={500}
      component={
        <MultipleShareForm
          leads={props.checked as any}
          onClose={props.setCompartilharMultipleAdmin}
          open={props.compartilharMultipleAdmin}
        />
      }
      setOpenModal={props.setCompartilharMultipleAdmin}
      open={props.compartilharMultipleAdmin}
      icon={<IconsSVG.ShareLeadIcon />}
    />

    {/* Transferir leads admin (múltiplos por equipe) */}
    <DialogCommon
      closeText="Fechar"
      saveText="Salvar"
      onClose={() => props.setTransferMultipleAdmin}
      onSave={() => {}}
      isRight={false}
      onClean={() => {}}
      title="Transferir leads"
      isFilter={false}
      isClose
      width={500}
      height={550}
      component={
        <MultipleTransferByEquipe
          leads={props.checked as any}
          onClose={props.setTransferMultipleAdmin}
          open={props.transferMultipleAdmin}
          hotRefreshFunc={() => props.requestLeads()}
          transferirTodasPaginas={props.allPagesSelected}
          idCorretorOrigem={props.idCorretorOrigem}
        />
      }
      setOpenModal={props.setTransferMultipleAdmin}
      open={props.transferMultipleAdmin}
      icon={<IconsSVG.TransferLeadIcon />}
    />

    {/* Compartilhar lead (individual) */}
    <DialogCommon
      closeText="Fechar"
      saveText="Salvar"
      onClose={() => props.setShared}
      onSave={() => {}}
      isRight={false}
      onClean={() => {}}
      title="Compartilhar lead"
      isFilter={false}
      isClose
      width={500}
      component={
        <ShareForm
          idLead={props.anchorLead}
          idLeadCorretor={props.anchorLeadCorretor}
          onClose={props.setShared}
          open={props.shared}
          hotRefreshFunc={() => console.log("Atualizar")}
        />
      }
      setOpenModal={props.setShared}
      open={props.shared}
      icon={<IconsSVG.ShareLeadIcon />}
    />

    {/* Transferir lead (individual) */}
    <DialogCommon
      closeText="Fechar"
      saveText="Salvar"
      onClose={() => props.setTransfer}
      onSave={() => {}}
      isRight={false}
      onClean={() => {}}
      title="Transferir lead"
      isFilter={false}
      isClose
      width={500}
      component={
        <TransferForm
          idLead={props.anchorLead}
          idLeadCorretor={props.anchorLeadCorretor}
          onClose={props.setTransfer}
          open={props.transfer}
          isLeadScreen={false}
          hotRefreshFunc={() => props.requestLeads()}
        />
      }
      setOpenModal={props.setTransfer}
      open={props.transfer}
      icon={<IconsSVG.TransferLeadIcon />}
    />

    {/* Histórico */}
    <DialogCommon
      closeText="Fechar"
      saveText="Salvar"
      onClose={() => props.setHistoric}
      onSave={() => {}}
      isRight={false}
      onClean={() => {}}
      title="Histórico"
      isFilter={false}
      isClose
      width={500}
      component={
        <HistoricForm
          idLead={props.anchorLead}
          idLeadCorretor={props.anchorLeadCorretor}
          onClose={props.setHistoric}
          open={props.historic}
        />
      }
      setOpenModal={props.setHistoric}
      open={props.historic}
      icon={<IconsSVG.HistoricIcon />}
    />

    {/* Etiquetas editor */}
    <DialogCommon
      closeText="Fechar"
      saveText="Salvar"
      onClose={() => props.setTagsOpen}
      onSave={() => {}}
      isRight={false}
      onClean={() => {}}
      titleHeader="Etiquetas"
      isFilter={false}
      isClose
      width={400}
      component={
        <TagEditor
          isOpen={props.tagsOpen}
          onClose={() => props.setTagsOpen(false)}
          tags={props.tags}
          refetch={() => {
            props.refetchEtiquetas();
            props.requestLeads();
          }}
        />
      }
      setOpenModal={props.setTagsOpen}
      open={props.tagsOpen}
      icon={<TagIcon />}
    />

    {/* Alterar Etiquetas (múltiplos) */}
    <DialogCommon
      closeText="Fechar"
      saveText="Salvar"
      onClose={() => props.setTagsMultipleOpen}
      onSave={() => {}}
      isRight={false}
      onClean={() => {}}
      titleHeader="Alterar Etiquetas"
      isFilter={false}
      isClose
      width={400}
      component={props.tagsMultipleContent}
      setOpenModal={props.setTagsMultipleOpen}
      open={props.tagsMultipleOpen}
      icon={<TagIcon />}
    />

    {/* Alterar Produtos (múltiplos) */}
    <DialogCommon
      closeText="Fechar"
      saveText="Aplicar"
      onClose={props.onCloseProdutosMultiple}
      onSave={props.onSaveProdutosMultiple}
      isRight={false}
      onClean={() => {}}
      titleHeader="Alterar Produtos"
      isFilter={false}
      isClose
      width={500}
      component={props.produtosMultipleContent}
      setOpenModal={props.setProdutosMultipleOpen}
      open={props.produtosMultipleOpen}
      icon={<ProdutoMultipleIcon />}
    />

    {/* Envio WhatsApp em Massa */}
    <DialogCommon
      closeText="Fechar"
      saveText="Salvar"
      onClose={() => props.setWhatsAppMassOpen(false)}
      onSave={() => {}}
      isRight={false}
      onClean={() => {}}
      titleHeader="Envio em Massa no WhatsApp"
      isFilter={false}
      isClose
      width="min(940px, calc(100vw - 56px))"
      maxHeight="86vh"
      component={
        <div
          style={{
            width: "100%",
            maxWidth: "100%",
            maxHeight: "70vh",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <EnvioMassaPanel
            contatos={props.whatsAppMassContacts}
            loading={false}
            onHistoryAppend={() => {}}
            selectionLocked
            onSendSuccess={() => props.setWhatsAppMassOpen(false)}
          />
        </div>
      }
      setOpenModal={props.setWhatsAppMassOpen}
      open={props.whatsAppMassOpen}
      icon={<WhatsAppMassIcon />}
    />

    {/* Atualizar Etapa */}
    <DialogCommon
      closeText="Fechar"
      saveText="Salvar"
      onClose={() => props.setEtapasOpen}
      onSave={() => {}}
      isRight={false}
      onClean={() => {}}
      titleHeader="Atualizar etapa"
      isFilter={false}
      isClose
      width={400}
      component={
        <EtapasModal
          onClose={() => props.setEtapasOpen(false)}
          open={props.etapasOpen}
          anchorLeadCorretor={props.anchorLeadCorretor}
          anchorLead={props.anchorLead}
          anchorEtapa={props.anchorEtapa}
          anchorSubEtapa={props.anchorSubEtapa}
          refetch={() => props.requestLeads()}
        />
      }
      setOpenModal={props.setEtapasOpen}
      open={props.etapasOpen}
      icon={<EtapaIcon />}
    />

    {/* Alterar Produtos (individual) */}
    <DialogCommon
      closeText="Fechar"
      saveText="Salvar"
      onClose={() => props.setProdutosOpen}
      onSave={() => {}}
      isRight={false}
      onClean={() => {}}
      titleHeader="Alterar produtos"
      isFilter={false}
      isClose
      width={500}
      component={
        <ProdutosModal
          onClose={() => props.setProdutosOpen(false)}
          open={props.produtosOpen}
          anchorLeadCorretor={props.anchorLeadCorretor}
          produtosAtuais={props.anchorProdutos}
          refetch={() => props.requestLeads()}
        />
      }
      setOpenModal={props.setProdutosOpen}
      open={props.produtosOpen}
      icon={<ProdutoIcon />}
    />

    {/* Atualizar Lead Modal */}
    <AtualizarLeadModal
      open={props.openAtualizarModal}
      onClose={() => props.setOpenAtualizarModal(false)}
      idLead365={props.selectedLeadId}
      onSuccess={() => props.requestLeads()}
    />
  </>
);
